import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import Heading from "../../components/home/Products/Heading";
import { Helmet } from "react-helmet";

const Thanks = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);

  return (
    <div className="max-w-container mx-auto px-4 pt-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Thank You - RK Global Trader</title>
        <meta
          name="description"
          content="Thank you for contacting RK Global Trader. Your enquiry has been successfully submitted. Our team will respond promptly regarding your export/import business inquiry."
        />
        <meta
          name="keywords"
          content="RK Global Trader, thank you page, enquiry submitted, export business, international trade, export products, contact confirmation, agriculture products, Export from India, trading website"
        />
        <meta name="author" content="RK Global Trader | Agriculture Product | Export from India" />
        <link rel="canonical" href="https://www.rkglobaltrader.com/thanks" />
      </Helmet>

      <Heading heading="You May Also Like - " />

      <div className="pb-4 pt-5 flex flex-col mdl:flex-row justify-center">
        <div className="thank-you-page text-center mdl:text-left">
          <h1 className="text-5xl font-semibold text-primeColor">Thank You for Contacting Us!</h1>
          <p className="pt-2 pb-1 text-lg">
            Your enquiry has been successfully submitted. Our dedicated export/import team will respond to your request promptly.
          </p>
          <p className="text-md">
            We provide high-quality agriculture products for international trade. Explore more of our best-selling products below.
          </p>
          <div className="flex flex-col mdl:flex-row justify-center py-4 px-4 items-center gap-2 mdl:gap-0">
            <div className="w-96 flex gap-4 justify-center">
              <Link to="/">
                <button className="w-52 h-10 bg-primeColor text-white text-lg mt-4 hover:bg-black duration-300">
                  Back to Home
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Display best-selling products to encourage further engagement */}
      <BestSellers />
    </div>
  );
};

export default Thanks;
